<template>
  <div class="div-contenidoComponente">
    <div class="div-campoDeBusquedaLineaDeProduccion">
      <input
        type="text"
        class="input-campoDeBusquedaLineaDeProduccion"
        :placeholder="$t('production.dump.orderLineSearch.input.placeholder')"
        :value="selectedValuesText"
        :disabled="true"
      >

      <div
        class="seleccionable div-OpcionesDelCampoBusquedaLineaDeProduccion"
        @click="isPopupOpened = true"
      >
        <img
          src="@/static/icons/ic_search.svg"
          width="20px"
          height="20px"
        >
      </div>
    </div>

    <f7-popup
      v-model:opened="isPopupOpened"
      class="busquedaLineas-popup"
    >
      <f7-page>
        <f7-navbar :style="appTheme">
          <f7-nav-left>
            <f7-link @click="closePopup">
              <img
                alt="iconClose"
                :src="icClose"
              >
            </f7-link>
            {{ $t('common.salesOrderLines') }}
          </f7-nav-left>
        </f7-navbar>

        <PCLineasPedidoVenta
          v-if="isPopupOpened"
          ref="itemsRef"
          @selected="handleSelected"
        />
      </f7-page>
    </f7-popup>
  </div>
</template>

<script setup>
// @ts-check
import icClose from '@/static/icons/ic_back.svg';
import PCLineasPedidoVenta from '@/components/production/traceability/PCLineasPedidoVenta.vue';
import { ref, shallowRef } from 'vue';

/** @import { ShallowRef } from 'vue' */
/** @import { LineaPedidoVenta } from '@erpagroapp/types' */

const emit = defineEmits(['selected']);

const appTheme = {
  '--f7-navbar-text-color': '#fff',
};

const isPopupOpened = ref(false);
const selectedValuesText = ref('');
/** @type {ShallowRef<InstanceType<typeof PCLineasPedidoVenta> | null>} */
const itemsRef = shallowRef(null);

function closePopup() {
  isPopupOpened.value = false;
  itemsRef.value?.EventListaSeleccionada();
}

/**
 * @param {LineaPedidoVenta[]} values
 * @returns {void}
 */
function handleSelected(values) {
  formatSelectedValues(values);
  emit('selected', values);
}

/**
 * @param {LineaPedidoVenta[]} values
 * @returns {void}
 */
function formatSelectedValues(values) {
  selectedValuesText.value = values
    .map((line) => `${line.PedidoVenta?.Serie ?? ''}/${line.PedidoVenta?.Numero}-${line.Orden}`)
    .join(', ');
}
</script>

<style scoped lang="scss">
.div-contenidoComponente {
  .div-campoDeBusquedaLineaDeProduccion {
    display: flex;
    background: var(--his-tierra-white);
    border: 1px solid var(--his-silver);
    border-radius: 8px;
    min-height: var(--search-input-height);
    width: 100%;
  }

  .input-campoDeBusquedaLineaDeProduccion {
    width: 100%;
    height: var(--search-input-height);
    padding: var(--search-input-padding);
    font-size: var(--search-input-font-size);
    color: #24253da8;
  }

  .div-OpcionesDelCampoBusquedaLineaDeProduccion {
    min-width: var(--search-btn-min-width);
    display: flex;
    align-items: center;
    justify-content: center;
    border-left: var(--search-btn-border-left);
  }
}
</style>
